/* tslint:disable */
/* eslint-disable */
/**
 * Sovex.Courier.DPD.ServiceWebsite
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddressViewModel
 */
export interface AddressViewModel {
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    'address'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    'addressAddition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    'zipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    'eori'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    'contactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AddressViewModel
     */
    'contactEmail'?: string | null;
}
/**
 * 
 * @export
 * @interface AverageClearanceTimeViewModel
 */
export interface AverageClearanceTimeViewModel {
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'today': number;
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'todayCount': number;
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'last7Days': number;
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'last7DaysCount': number;
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'last30Days': number;
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'last30DaysCount': number;
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'last180Days': number;
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'last180DaysCount': number;
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'custom': number;
    /**
     * 
     * @type {number}
     * @memberof AverageClearanceTimeViewModel
     */
    'customCount': number;
}
/**
 * 
 * @export
 * @interface ClearedShipmentDropdownsModel
 */
export interface ClearedShipmentDropdownsModel {
    /**
     * 
     * @type {Array<StringStringKeyValueModel>}
     * @memberof ClearedShipmentDropdownsModel
     */
    'mawbs'?: Array<StringStringKeyValueModel> | null;
    /**
     * 
     * @type {Array<StringStringKeyValueModel>}
     * @memberof ClearedShipmentDropdownsModel
     */
    'mrns'?: Array<StringStringKeyValueModel> | null;
}
/**
 * 
 * @export
 * @interface ClearedShipmentsModel
 */
export interface ClearedShipmentsModel {
    /**
     * 
     * @type {number}
     * @memberof ClearedShipmentsModel
     */
    'cleared': number;
    /**
     * 
     * @type {number}
     * @memberof ClearedShipmentsModel
     */
    'preCleared': number;
    /**
     * 
     * @type {number}
     * @memberof ClearedShipmentsModel
     */
    'notCleared': number;
    /**
     * 
     * @type {number}
     * @memberof ClearedShipmentsModel
     */
    'totalShipments': number;
}
/**
 * 
 * @export
 * @interface CustomsHandlingViewModel
 */
export interface CustomsHandlingViewModel {
    /**
     * 
     * @type {number}
     * @memberof CustomsHandlingViewModel
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'hawb'?: string | null;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof CustomsHandlingViewModel
     */
    'shipperAddress': AddressViewModel;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof CustomsHandlingViewModel
     */
    'deliveryAddress': AddressViewModel;
    /**
     * 
     * @type {number}
     * @memberof CustomsHandlingViewModel
     */
    'pieces': number;
    /**
     * 
     * @type {number}
     * @memberof CustomsHandlingViewModel
     */
    'realWeight': number;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'incoterms'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomsHandlingViewModel
     */
    'invoiceAmount': number;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'invoiceNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'pincode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'articleCondition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'reasonForImport'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomsHandlingViewModel
     */
    'valueOfGoods': number;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'valueOfGoodsCurrency'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomsHandlingViewModel
     */
    'freightCosts': number;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'freightCostsCurrency'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomsHandlingViewModel
     */
    'paymentValue': number;
    /**
     * 
     * @type {string}
     * @memberof CustomsHandlingViewModel
     */
    'paymentValueCurrency'?: string | null;
    /**
     * 
     * @type {Array<DocumentViewModel>}
     * @memberof CustomsHandlingViewModel
     */
    'documents'?: Array<DocumentViewModel> | null;
    /**
     * 
     * @type {Array<MilestoneViewModel>}
     * @memberof CustomsHandlingViewModel
     */
    'milestones'?: Array<MilestoneViewModel> | null;
}
/**
 * 
 * @export
 * @interface DocumentViewModel
 */
export interface DocumentViewModel {
    /**
     * 
     * @type {number}
     * @memberof DocumentViewModel
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentViewModel
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentViewModel
     */
    'friendlyDate'?: string | null;
}
/**
 * 
 * @export
 * @interface EditContactDetailsViewModel
 */
export interface EditContactDetailsViewModel {
    /**
     * 
     * @type {string}
     * @memberof EditContactDetailsViewModel
     */
    'hawb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditContactDetailsViewModel
     */
    'phoneNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditContactDetailsViewModel
     */
    'emailAddress'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginResultViewModel
 */
export interface LoginResultViewModel {
    /**
     * 
     * @type {boolean}
     * @memberof LoginResultViewModel
     */
    'success': boolean;
    /**
     * 
     * @type {number}
     * @memberof LoginResultViewModel
     */
    'userId': number;
    /**
     * 
     * @type {string}
     * @memberof LoginResultViewModel
     */
    'errorMessage'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginViewModel
 */
export interface LoginViewModel {
    /**
     * 
     * @type {string}
     * @memberof LoginViewModel
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginViewModel
     */
    'password'?: string | null;
}
/**
 * 
 * @export
 * @interface MawbMrnModel
 */
export interface MawbMrnModel {
    /**
     * 
     * @type {number}
     * @memberof MawbMrnModel
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MawbMrnModel
     */
    'hawb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MawbMrnModel
     */
    'mawb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MawbMrnModel
     */
    'sender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MawbMrnModel
     */
    'mrn'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'waitingForPoA': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'waitingForCustomsClearance': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'preCleared': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'finalCleared': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'documentCustomsInspection': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'physicalCustomsInspection': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'pendingForPaymentDapOnly': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'missing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'destroyedConficatedByCustoms': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'returnShipments': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MawbMrnModel
     */
    'isProblemShipment': boolean;
}
/**
 * 
 * @export
 * @interface MawbsAndMrnsModel
 */
export interface MawbsAndMrnsModel {
    /**
     * 
     * @type {Array<StringStringKeyValueModel>}
     * @memberof MawbsAndMrnsModel
     */
    'mawbList'?: Array<StringStringKeyValueModel> | null;
    /**
     * 
     * @type {Array<StringStringKeyValueModel>}
     * @memberof MawbsAndMrnsModel
     */
    'mrnList'?: Array<StringStringKeyValueModel> | null;
}
/**
 * 
 * @export
 * @interface MilestoneViewModel
 */
export interface MilestoneViewModel {
    /**
     * 
     * @type {number}
     * @memberof MilestoneViewModel
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof MilestoneViewModel
     */
    'milestoneId': number;
    /**
     * 
     * @type {string}
     * @memberof MilestoneViewModel
     */
    'milestoneName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MilestoneViewModel
     */
    'milestoneComment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MilestoneViewModel
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof MilestoneViewModel
     */
    'milestoneDescription'?: string | null;
}
/**
 * 
 * @export
 * @interface ProblemShipmentModel
 */
export interface ProblemShipmentModel {
    /**
     * 
     * @type {number}
     * @memberof ProblemShipmentModel
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ProblemShipmentModel
     */
    'customsHandlingMilestoneId': number;
    /**
     * 
     * @type {number}
     * @memberof ProblemShipmentModel
     */
    'customsHandlingBlockingMilestoneId': number;
    /**
     * 
     * @type {number}
     * @memberof ProblemShipmentModel
     */
    'milestoneCustomsHandlingId': number;
    /**
     * 
     * @type {number}
     * @memberof ProblemShipmentModel
     */
    'customsHandlingBlockingMilestoneRemarkId': number;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'hawb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'mawb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'blockingMilestone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'milestoneDatetime': string;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'receiverName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'incoterm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'lastRemark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'remark'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'category'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemShipmentModel
     */
    'pieces': number;
    /**
     * 
     * @type {number}
     * @memberof ProblemShipmentModel
     */
    'value'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'valueCurrency'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemShipmentModel
     */
    'weight': number;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'shipperName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'shipperAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'shipperAddAddr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'shipperZipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'shipperCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'shipperCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'invoiceName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'invoiceAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'invoiceAddAddr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'invoiceZipcode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'invoiceCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'invoiceCountry'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'eoriNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemShipmentModel
     */
    'niederlassungsnummer'?: string | null;
    /**
     * 
     * @type {Array<File>}
     * @memberof ProblemShipmentModel
     */
    'documents'?: Array<File> | null;
}
/**
 * 
 * @export
 * @interface ResendNotificationViewModel
 */
export interface ResendNotificationViewModel {
    /**
     * 
     * @type {number}
     * @memberof ResendNotificationViewModel
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface SearchResultViewModel
 */
export interface SearchResultViewModel {
    /**
     * 
     * @type {number}
     * @memberof SearchResultViewModel
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SearchResultViewModel
     */
    'hawb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchResultViewModel
     */
    'mawb'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchResultViewModel
     */
    'sender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchResultViewModel
     */
    'mrn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchResultViewModel
     */
    'lastMilestone'?: string | null;
}
/**
 * 
 * @export
 * @interface StringStringKeyValueModel
 */
export interface StringStringKeyValueModel {
    /**
     * 
     * @type {string}
     * @memberof StringStringKeyValueModel
     */
    'key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringStringKeyValueModel
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface StringValueTextModel
 */
export interface StringValueTextModel {
    /**
     * 
     * @type {string}
     * @memberof StringValueTextModel
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringValueTextModel
     */
    'text'?: string | null;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LoginViewModel} [loginViewModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginViewModel?: LoginViewModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/Login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginViewModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Account/Logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {LoginViewModel} [loginViewModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginViewModel?: LoginViewModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResultViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginViewModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @param {LoginViewModel} [loginViewModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginViewModel?: LoginViewModel, options?: any): AxiosPromise<LoginResultViewModel> {
            return localVarFp.login(loginViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: any): AxiosPromise<void> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @param {LoginViewModel} [loginViewModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public login(loginViewModel?: LoginViewModel, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).login(loginViewModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public logout(options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CustomsHandlingApi - axios parameter creator
 * @export
 */
export const CustomsHandlingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EditContactDetailsViewModel} [editContactDetailsViewModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editContactDetails: async (editContactDetailsViewModel?: EditContactDetailsViewModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CustomsHandling/EditContactDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editContactDetailsViewModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemById: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CustomsHandling/GetItemById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResendNotificationViewModel} [resendNotificationViewModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendNotification: async (resendNotificationViewModel?: ResendNotificationViewModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CustomsHandling/ResendNotification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendNotificationViewModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [reference] 
         * @param {string} [customer] 
         * @param {string} [mrn] 
         * @param {string} [mawb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (reference?: string, customer?: string, mrn?: string, mawb?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CustomsHandling/Search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reference !== undefined) {
                localVarQueryParameter['reference'] = reference;
            }

            if (customer !== undefined) {
                localVarQueryParameter['customer'] = customer;
            }

            if (mrn !== undefined) {
                localVarQueryParameter['mrn'] = mrn;
            }

            if (mawb !== undefined) {
                localVarQueryParameter['mawb'] = mawb;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomsHandlingApi - functional programming interface
 * @export
 */
export const CustomsHandlingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomsHandlingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EditContactDetailsViewModel} [editContactDetailsViewModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editContactDetails(editContactDetailsViewModel?: EditContactDetailsViewModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editContactDetails(editContactDetailsViewModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getItemById(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomsHandlingViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getItemById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ResendNotificationViewModel} [resendNotificationViewModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendNotification(resendNotificationViewModel?: ResendNotificationViewModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendNotification(resendNotificationViewModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [reference] 
         * @param {string} [customer] 
         * @param {string} [mrn] 
         * @param {string} [mawb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(reference?: string, customer?: string, mrn?: string, mawb?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchResultViewModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(reference, customer, mrn, mawb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CustomsHandlingApi - factory interface
 * @export
 */
export const CustomsHandlingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomsHandlingApiFp(configuration)
    return {
        /**
         * 
         * @param {EditContactDetailsViewModel} [editContactDetailsViewModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editContactDetails(editContactDetailsViewModel?: EditContactDetailsViewModel, options?: any): AxiosPromise<void> {
            return localVarFp.editContactDetails(editContactDetailsViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getItemById(id?: number, options?: any): AxiosPromise<CustomsHandlingViewModel> {
            return localVarFp.getItemById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResendNotificationViewModel} [resendNotificationViewModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendNotification(resendNotificationViewModel?: ResendNotificationViewModel, options?: any): AxiosPromise<void> {
            return localVarFp.resendNotification(resendNotificationViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [reference] 
         * @param {string} [customer] 
         * @param {string} [mrn] 
         * @param {string} [mawb] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(reference?: string, customer?: string, mrn?: string, mawb?: string, options?: any): AxiosPromise<Array<SearchResultViewModel>> {
            return localVarFp.search(reference, customer, mrn, mawb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomsHandlingApi - object-oriented interface
 * @export
 * @class CustomsHandlingApi
 * @extends {BaseAPI}
 */
export class CustomsHandlingApi extends BaseAPI {
    /**
     * 
     * @param {EditContactDetailsViewModel} [editContactDetailsViewModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomsHandlingApi
     */
    public editContactDetails(editContactDetailsViewModel?: EditContactDetailsViewModel, options?: AxiosRequestConfig) {
        return CustomsHandlingApiFp(this.configuration).editContactDetails(editContactDetailsViewModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomsHandlingApi
     */
    public getItemById(id?: number, options?: AxiosRequestConfig) {
        return CustomsHandlingApiFp(this.configuration).getItemById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResendNotificationViewModel} [resendNotificationViewModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomsHandlingApi
     */
    public resendNotification(resendNotificationViewModel?: ResendNotificationViewModel, options?: AxiosRequestConfig) {
        return CustomsHandlingApiFp(this.configuration).resendNotification(resendNotificationViewModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [reference] 
     * @param {string} [customer] 
     * @param {string} [mrn] 
     * @param {string} [mawb] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomsHandlingApi
     */
    public search(reference?: string, customer?: string, mrn?: string, mawb?: string, options?: AxiosRequestConfig) {
        return CustomsHandlingApiFp(this.configuration).search(reference, customer, mrn, mawb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageClearanceTime: async (start?: string, end?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/GetAverageClearanceTime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClearedShipments: async (mawb?: string, mrn?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/GetClearedShipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mawb !== undefined) {
                localVarQueryParameter['mawb'] = mawb;
            }

            if (mrn !== undefined) {
                localVarQueryParameter['mrn'] = mrn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMawbAndMrn: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Dashboard/GetMawbAndMrn`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAverageClearanceTime(start?: string, end?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AverageClearanceTimeViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAverageClearanceTime(start, end, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClearedShipments(mawb?: string, mrn?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClearedShipmentsModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClearedShipments(mawb, mrn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMawbAndMrn(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClearedShipmentDropdownsModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMawbAndMrn(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAverageClearanceTime(start?: string, end?: string, options?: any): AxiosPromise<AverageClearanceTimeViewModel> {
            return localVarFp.getAverageClearanceTime(start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClearedShipments(mawb?: string, mrn?: string, options?: any): AxiosPromise<ClearedShipmentsModel> {
            return localVarFp.getClearedShipments(mawb, mrn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMawbAndMrn(options?: any): AxiosPromise<ClearedShipmentDropdownsModel> {
            return localVarFp.getMawbAndMrn(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getAverageClearanceTime(start?: string, end?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getAverageClearanceTime(start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [mawb] 
     * @param {string} [mrn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getClearedShipments(mawb?: string, mrn?: string, options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getClearedShipments(mawb, mrn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardApi
     */
    public getMawbAndMrn(options?: AxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getMawbAndMrn(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DataApi - axios parameter creator
 * @export
 */
export const DataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesOfOrigin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Data/GetCountriesOfOrigin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Data/GetCurrencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataApi - functional programming interface
 * @export
 */
export const DataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountriesOfOrigin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StringValueTextModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountriesOfOrigin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrencies(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrencies(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DataApi - factory interface
 * @export
 */
export const DataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountriesOfOrigin(options?: any): AxiosPromise<Array<StringValueTextModel>> {
            return localVarFp.getCountriesOfOrigin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrencies(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getCurrencies(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataApi - object-oriented interface
 * @export
 * @class DataApi
 * @extends {BaseAPI}
 */
export class DataApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getCountriesOfOrigin(options?: AxiosRequestConfig) {
        return DataApiFp(this.configuration).getCountriesOfOrigin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getCurrencies(options?: AxiosRequestConfig) {
        return DataApiFp(this.configuration).getCurrencies(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download: async (id?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Document/Download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async download(id?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.download(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        download(id?: number, options?: any): AxiosPromise<File> {
            return localVarFp.download(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
    /**
     * 
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public download(id?: number, options?: AxiosRequestConfig) {
        return DocumentApiFp(this.configuration).download(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MawbMrnApi - axios parameter creator
 * @export
 */
export const MawbMrnApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMawbMrnShipments: async (mawb?: string, mrn?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MawbMrn/DownloadMawbMrnShipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mawb !== undefined) {
                localVarQueryParameter['mawb'] = mawb;
            }

            if (mrn !== undefined) {
                localVarQueryParameter['mrn'] = mrn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMawbMrnShipments: async (mawb?: string, mrn?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MawbMrn/GetMawbMrnShipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mawb !== undefined) {
                localVarQueryParameter['mawb'] = mawb;
            }

            if (mrn !== undefined) {
                localVarQueryParameter['mrn'] = mrn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMawbsAndMrns: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/MawbMrn/GetMawbsAndMrns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MawbMrnApi - functional programming interface
 * @export
 */
export const MawbMrnApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MawbMrnApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadMawbMrnShipments(mawb?: string, mrn?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadMawbMrnShipments(mawb, mrn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMawbMrnShipments(mawb?: string, mrn?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MawbMrnModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMawbMrnShipments(mawb, mrn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMawbsAndMrns(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MawbsAndMrnsModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMawbsAndMrns(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MawbMrnApi - factory interface
 * @export
 */
export const MawbMrnApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MawbMrnApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadMawbMrnShipments(mawb?: string, mrn?: string, options?: any): AxiosPromise<File> {
            return localVarFp.downloadMawbMrnShipments(mawb, mrn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMawbMrnShipments(mawb?: string, mrn?: string, options?: any): AxiosPromise<Array<MawbMrnModel>> {
            return localVarFp.getMawbMrnShipments(mawb, mrn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMawbsAndMrns(options?: any): AxiosPromise<MawbsAndMrnsModel> {
            return localVarFp.getMawbsAndMrns(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MawbMrnApi - object-oriented interface
 * @export
 * @class MawbMrnApi
 * @extends {BaseAPI}
 */
export class MawbMrnApi extends BaseAPI {
    /**
     * 
     * @param {string} [mawb] 
     * @param {string} [mrn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MawbMrnApi
     */
    public downloadMawbMrnShipments(mawb?: string, mrn?: string, options?: AxiosRequestConfig) {
        return MawbMrnApiFp(this.configuration).downloadMawbMrnShipments(mawb, mrn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [mawb] 
     * @param {string} [mrn] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MawbMrnApi
     */
    public getMawbMrnShipments(mawb?: string, mrn?: string, options?: AxiosRequestConfig) {
        return MawbMrnApiFp(this.configuration).getMawbMrnShipments(mawb, mrn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MawbMrnApi
     */
    public getMawbsAndMrns(options?: AxiosRequestConfig) {
        return MawbMrnApiFp(this.configuration).getMawbsAndMrns(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProblemShipmentsApi - axios parameter creator
 * @export
 */
export const ProblemShipmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblemShipments: async (mawb?: string, mrn?: string, start?: string, end?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProblemShipments/GetProblemShipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mawb !== undefined) {
                localVarQueryParameter['mawb'] = mawb;
            }

            if (mrn !== undefined) {
                localVarQueryParameter['mrn'] = mrn;
            }

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString() :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString() :
                    end;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {number} [customsHandlingMilestoneId] 
         * @param {number} [customsHandlingBlockingMilestoneId] 
         * @param {number} [milestoneCustomsHandlingId] 
         * @param {number} [customsHandlingBlockingMilestoneRemarkId] 
         * @param {string} [hAWB] 
         * @param {string} [mAWB] 
         * @param {string} [blockingMilestone] 
         * @param {string} [milestoneDatetime] 
         * @param {string} [receiverName] 
         * @param {string} [incoterm] 
         * @param {string} [lastRemark] 
         * @param {string} [remark] 
         * @param {string} [category] 
         * @param {number} [pieces] 
         * @param {number} [value] 
         * @param {string} [valueCurrency] 
         * @param {number} [weight] 
         * @param {string} [shipperName] 
         * @param {string} [shipperAddress] 
         * @param {string} [shipperAddAddr] 
         * @param {string} [shipperZipcode] 
         * @param {string} [shipperCity] 
         * @param {string} [shipperCountry] 
         * @param {string} [invoiceName] 
         * @param {string} [invoiceAddress] 
         * @param {string} [invoiceAddAddr] 
         * @param {string} [invoiceZipcode] 
         * @param {string} [invoiceCity] 
         * @param {string} [invoiceCountry] 
         * @param {string} [eoriNumber] 
         * @param {string} [niederlassungsnummer] 
         * @param {Array<File>} [documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProblemShipments: async (id?: number, customsHandlingMilestoneId?: number, customsHandlingBlockingMilestoneId?: number, milestoneCustomsHandlingId?: number, customsHandlingBlockingMilestoneRemarkId?: number, hAWB?: string, mAWB?: string, blockingMilestone?: string, milestoneDatetime?: string, receiverName?: string, incoterm?: string, lastRemark?: string, remark?: string, category?: string, pieces?: number, value?: number, valueCurrency?: string, weight?: number, shipperName?: string, shipperAddress?: string, shipperAddAddr?: string, shipperZipcode?: string, shipperCity?: string, shipperCountry?: string, invoiceName?: string, invoiceAddress?: string, invoiceAddAddr?: string, invoiceZipcode?: string, invoiceCity?: string, invoiceCountry?: string, eoriNumber?: string, niederlassungsnummer?: string, documents?: Array<File>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProblemShipments/SaveProblemShipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (id !== undefined) { 
                localVarFormParams.append('Id', id as any);
            }
    
            if (customsHandlingMilestoneId !== undefined) { 
                localVarFormParams.append('CustomsHandlingMilestoneId', customsHandlingMilestoneId as any);
            }
    
            if (customsHandlingBlockingMilestoneId !== undefined) { 
                localVarFormParams.append('CustomsHandlingBlockingMilestoneId', customsHandlingBlockingMilestoneId as any);
            }
    
            if (milestoneCustomsHandlingId !== undefined) { 
                localVarFormParams.append('MilestoneCustomsHandlingId', milestoneCustomsHandlingId as any);
            }
    
            if (customsHandlingBlockingMilestoneRemarkId !== undefined) { 
                localVarFormParams.append('CustomsHandlingBlockingMilestoneRemarkId', customsHandlingBlockingMilestoneRemarkId as any);
            }
    
            if (hAWB !== undefined) { 
                localVarFormParams.append('HAWB', hAWB as any);
            }
    
            if (mAWB !== undefined) { 
                localVarFormParams.append('MAWB', mAWB as any);
            }
    
            if (blockingMilestone !== undefined) { 
                localVarFormParams.append('BlockingMilestone', blockingMilestone as any);
            }
    
            if (milestoneDatetime !== undefined) { 
                localVarFormParams.append('MilestoneDatetime', milestoneDatetime as any);
            }
    
            if (receiverName !== undefined) { 
                localVarFormParams.append('ReceiverName', receiverName as any);
            }
    
            if (incoterm !== undefined) { 
                localVarFormParams.append('Incoterm', incoterm as any);
            }
    
            if (lastRemark !== undefined) { 
                localVarFormParams.append('LastRemark', lastRemark as any);
            }
    
            if (remark !== undefined) { 
                localVarFormParams.append('Remark', remark as any);
            }
    
            if (category !== undefined) { 
                localVarFormParams.append('Category', category as any);
            }
    
            if (pieces !== undefined) { 
                localVarFormParams.append('Pieces', pieces as any);
            }
    
            if (value !== undefined) { 
                localVarFormParams.append('Value', value as any);
            }
    
            if (valueCurrency !== undefined) { 
                localVarFormParams.append('ValueCurrency', valueCurrency as any);
            }
    
            if (weight !== undefined) { 
                localVarFormParams.append('Weight', weight as any);
            }
    
            if (shipperName !== undefined) { 
                localVarFormParams.append('ShipperName', shipperName as any);
            }
    
            if (shipperAddress !== undefined) { 
                localVarFormParams.append('ShipperAddress', shipperAddress as any);
            }
    
            if (shipperAddAddr !== undefined) { 
                localVarFormParams.append('ShipperAddAddr', shipperAddAddr as any);
            }
    
            if (shipperZipcode !== undefined) { 
                localVarFormParams.append('ShipperZipcode', shipperZipcode as any);
            }
    
            if (shipperCity !== undefined) { 
                localVarFormParams.append('ShipperCity', shipperCity as any);
            }
    
            if (shipperCountry !== undefined) { 
                localVarFormParams.append('ShipperCountry', shipperCountry as any);
            }
    
            if (invoiceName !== undefined) { 
                localVarFormParams.append('InvoiceName', invoiceName as any);
            }
    
            if (invoiceAddress !== undefined) { 
                localVarFormParams.append('InvoiceAddress', invoiceAddress as any);
            }
    
            if (invoiceAddAddr !== undefined) { 
                localVarFormParams.append('InvoiceAddAddr', invoiceAddAddr as any);
            }
    
            if (invoiceZipcode !== undefined) { 
                localVarFormParams.append('InvoiceZipcode', invoiceZipcode as any);
            }
    
            if (invoiceCity !== undefined) { 
                localVarFormParams.append('InvoiceCity', invoiceCity as any);
            }
    
            if (invoiceCountry !== undefined) { 
                localVarFormParams.append('InvoiceCountry', invoiceCountry as any);
            }
    
            if (eoriNumber !== undefined) { 
                localVarFormParams.append('EoriNumber', eoriNumber as any);
            }
    
            if (niederlassungsnummer !== undefined) { 
                localVarFormParams.append('Niederlassungsnummer', niederlassungsnummer as any);
            }
                if (documents) {
                documents.forEach((element) => {
                    localVarFormParams.append('Documents', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProblemShipmentsApi - functional programming interface
 * @export
 */
export const ProblemShipmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProblemShipmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProblemShipments(mawb?: string, mrn?: string, start?: string, end?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProblemShipmentModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProblemShipments(mawb, mrn, start, end, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {number} [customsHandlingMilestoneId] 
         * @param {number} [customsHandlingBlockingMilestoneId] 
         * @param {number} [milestoneCustomsHandlingId] 
         * @param {number} [customsHandlingBlockingMilestoneRemarkId] 
         * @param {string} [hAWB] 
         * @param {string} [mAWB] 
         * @param {string} [blockingMilestone] 
         * @param {string} [milestoneDatetime] 
         * @param {string} [receiverName] 
         * @param {string} [incoterm] 
         * @param {string} [lastRemark] 
         * @param {string} [remark] 
         * @param {string} [category] 
         * @param {number} [pieces] 
         * @param {number} [value] 
         * @param {string} [valueCurrency] 
         * @param {number} [weight] 
         * @param {string} [shipperName] 
         * @param {string} [shipperAddress] 
         * @param {string} [shipperAddAddr] 
         * @param {string} [shipperZipcode] 
         * @param {string} [shipperCity] 
         * @param {string} [shipperCountry] 
         * @param {string} [invoiceName] 
         * @param {string} [invoiceAddress] 
         * @param {string} [invoiceAddAddr] 
         * @param {string} [invoiceZipcode] 
         * @param {string} [invoiceCity] 
         * @param {string} [invoiceCountry] 
         * @param {string} [eoriNumber] 
         * @param {string} [niederlassungsnummer] 
         * @param {Array<File>} [documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveProblemShipments(id?: number, customsHandlingMilestoneId?: number, customsHandlingBlockingMilestoneId?: number, milestoneCustomsHandlingId?: number, customsHandlingBlockingMilestoneRemarkId?: number, hAWB?: string, mAWB?: string, blockingMilestone?: string, milestoneDatetime?: string, receiverName?: string, incoterm?: string, lastRemark?: string, remark?: string, category?: string, pieces?: number, value?: number, valueCurrency?: string, weight?: number, shipperName?: string, shipperAddress?: string, shipperAddAddr?: string, shipperZipcode?: string, shipperCity?: string, shipperCountry?: string, invoiceName?: string, invoiceAddress?: string, invoiceAddAddr?: string, invoiceZipcode?: string, invoiceCity?: string, invoiceCountry?: string, eoriNumber?: string, niederlassungsnummer?: string, documents?: Array<File>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProblemShipmentModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveProblemShipments(id, customsHandlingMilestoneId, customsHandlingBlockingMilestoneId, milestoneCustomsHandlingId, customsHandlingBlockingMilestoneRemarkId, hAWB, mAWB, blockingMilestone, milestoneDatetime, receiverName, incoterm, lastRemark, remark, category, pieces, value, valueCurrency, weight, shipperName, shipperAddress, shipperAddAddr, shipperZipcode, shipperCity, shipperCountry, invoiceName, invoiceAddress, invoiceAddAddr, invoiceZipcode, invoiceCity, invoiceCountry, eoriNumber, niederlassungsnummer, documents, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProblemShipmentsApi - factory interface
 * @export
 */
export const ProblemShipmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProblemShipmentsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [mawb] 
         * @param {string} [mrn] 
         * @param {string} [start] 
         * @param {string} [end] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProblemShipments(mawb?: string, mrn?: string, start?: string, end?: string, options?: any): AxiosPromise<Array<ProblemShipmentModel>> {
            return localVarFp.getProblemShipments(mawb, mrn, start, end, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [id] 
         * @param {number} [customsHandlingMilestoneId] 
         * @param {number} [customsHandlingBlockingMilestoneId] 
         * @param {number} [milestoneCustomsHandlingId] 
         * @param {number} [customsHandlingBlockingMilestoneRemarkId] 
         * @param {string} [hAWB] 
         * @param {string} [mAWB] 
         * @param {string} [blockingMilestone] 
         * @param {string} [milestoneDatetime] 
         * @param {string} [receiverName] 
         * @param {string} [incoterm] 
         * @param {string} [lastRemark] 
         * @param {string} [remark] 
         * @param {string} [category] 
         * @param {number} [pieces] 
         * @param {number} [value] 
         * @param {string} [valueCurrency] 
         * @param {number} [weight] 
         * @param {string} [shipperName] 
         * @param {string} [shipperAddress] 
         * @param {string} [shipperAddAddr] 
         * @param {string} [shipperZipcode] 
         * @param {string} [shipperCity] 
         * @param {string} [shipperCountry] 
         * @param {string} [invoiceName] 
         * @param {string} [invoiceAddress] 
         * @param {string} [invoiceAddAddr] 
         * @param {string} [invoiceZipcode] 
         * @param {string} [invoiceCity] 
         * @param {string} [invoiceCountry] 
         * @param {string} [eoriNumber] 
         * @param {string} [niederlassungsnummer] 
         * @param {Array<File>} [documents] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveProblemShipments(id?: number, customsHandlingMilestoneId?: number, customsHandlingBlockingMilestoneId?: number, milestoneCustomsHandlingId?: number, customsHandlingBlockingMilestoneRemarkId?: number, hAWB?: string, mAWB?: string, blockingMilestone?: string, milestoneDatetime?: string, receiverName?: string, incoterm?: string, lastRemark?: string, remark?: string, category?: string, pieces?: number, value?: number, valueCurrency?: string, weight?: number, shipperName?: string, shipperAddress?: string, shipperAddAddr?: string, shipperZipcode?: string, shipperCity?: string, shipperCountry?: string, invoiceName?: string, invoiceAddress?: string, invoiceAddAddr?: string, invoiceZipcode?: string, invoiceCity?: string, invoiceCountry?: string, eoriNumber?: string, niederlassungsnummer?: string, documents?: Array<File>, options?: any): AxiosPromise<ProblemShipmentModel> {
            return localVarFp.saveProblemShipments(id, customsHandlingMilestoneId, customsHandlingBlockingMilestoneId, milestoneCustomsHandlingId, customsHandlingBlockingMilestoneRemarkId, hAWB, mAWB, blockingMilestone, milestoneDatetime, receiverName, incoterm, lastRemark, remark, category, pieces, value, valueCurrency, weight, shipperName, shipperAddress, shipperAddAddr, shipperZipcode, shipperCity, shipperCountry, invoiceName, invoiceAddress, invoiceAddAddr, invoiceZipcode, invoiceCity, invoiceCountry, eoriNumber, niederlassungsnummer, documents, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProblemShipmentsApi - object-oriented interface
 * @export
 * @class ProblemShipmentsApi
 * @extends {BaseAPI}
 */
export class ProblemShipmentsApi extends BaseAPI {
    /**
     * 
     * @param {string} [mawb] 
     * @param {string} [mrn] 
     * @param {string} [start] 
     * @param {string} [end] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemShipmentsApi
     */
    public getProblemShipments(mawb?: string, mrn?: string, start?: string, end?: string, options?: AxiosRequestConfig) {
        return ProblemShipmentsApiFp(this.configuration).getProblemShipments(mawb, mrn, start, end, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [id] 
     * @param {number} [customsHandlingMilestoneId] 
     * @param {number} [customsHandlingBlockingMilestoneId] 
     * @param {number} [milestoneCustomsHandlingId] 
     * @param {number} [customsHandlingBlockingMilestoneRemarkId] 
     * @param {string} [hAWB] 
     * @param {string} [mAWB] 
     * @param {string} [blockingMilestone] 
     * @param {string} [milestoneDatetime] 
     * @param {string} [receiverName] 
     * @param {string} [incoterm] 
     * @param {string} [lastRemark] 
     * @param {string} [remark] 
     * @param {string} [category] 
     * @param {number} [pieces] 
     * @param {number} [value] 
     * @param {string} [valueCurrency] 
     * @param {number} [weight] 
     * @param {string} [shipperName] 
     * @param {string} [shipperAddress] 
     * @param {string} [shipperAddAddr] 
     * @param {string} [shipperZipcode] 
     * @param {string} [shipperCity] 
     * @param {string} [shipperCountry] 
     * @param {string} [invoiceName] 
     * @param {string} [invoiceAddress] 
     * @param {string} [invoiceAddAddr] 
     * @param {string} [invoiceZipcode] 
     * @param {string} [invoiceCity] 
     * @param {string} [invoiceCountry] 
     * @param {string} [eoriNumber] 
     * @param {string} [niederlassungsnummer] 
     * @param {Array<File>} [documents] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProblemShipmentsApi
     */
    public saveProblemShipments(id?: number, customsHandlingMilestoneId?: number, customsHandlingBlockingMilestoneId?: number, milestoneCustomsHandlingId?: number, customsHandlingBlockingMilestoneRemarkId?: number, hAWB?: string, mAWB?: string, blockingMilestone?: string, milestoneDatetime?: string, receiverName?: string, incoterm?: string, lastRemark?: string, remark?: string, category?: string, pieces?: number, value?: number, valueCurrency?: string, weight?: number, shipperName?: string, shipperAddress?: string, shipperAddAddr?: string, shipperZipcode?: string, shipperCity?: string, shipperCountry?: string, invoiceName?: string, invoiceAddress?: string, invoiceAddAddr?: string, invoiceZipcode?: string, invoiceCity?: string, invoiceCountry?: string, eoriNumber?: string, niederlassungsnummer?: string, documents?: Array<File>, options?: AxiosRequestConfig) {
        return ProblemShipmentsApiFp(this.configuration).saveProblemShipments(id, customsHandlingMilestoneId, customsHandlingBlockingMilestoneId, milestoneCustomsHandlingId, customsHandlingBlockingMilestoneRemarkId, hAWB, mAWB, blockingMilestone, milestoneDatetime, receiverName, incoterm, lastRemark, remark, category, pieces, value, valueCurrency, weight, shipperName, shipperAddress, shipperAddAddr, shipperZipcode, shipperCity, shipperCountry, invoiceName, invoiceAddress, invoiceAddAddr, invoiceZipcode, invoiceCity, invoiceCountry, eoriNumber, niederlassungsnummer, documents, options).then((request) => request(this.axios, this.basePath));
    }
}


